import userAxios from "../includes/axios"

async function getPrize(id: string|number){
	return (await userAxios.get('/api/user-side/getPrize/' + id)).data
}

export {
	getPrize
}